// Refresh control with a relative "last updated" label for one-shot data pages.
import { RefreshCw } from 'lucide-react';
import { timeAgo } from '../lib/format';

export function RefreshButton({
  lastUpdated,
  busy,
  onClick,
}: {
  lastUpdated: Date | null;
  busy: boolean;
  onClick: () => void;
}) {
  return (
    <div className="flex items-center gap-3">
      {lastUpdated && (
        <span className="text-xs text-slate-400">
          Updated {timeAgo(lastUpdated)}
        </span>
      )}
      <button
        onClick={onClick}
        disabled={busy}
        className="inline-flex items-center gap-1.5 rounded-md border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-600 transition hover:bg-slate-50 disabled:opacity-60"
      >
        <RefreshCw size={14} className={busy ? 'animate-spin' : ''} />
        {busy ? 'Refreshing…' : 'Refresh'}
      </button>
    </div>
  );
}
